import {
  Card,
  CardContent
} from '@mui/material'

import React from 'react'
import { useDrag, useDrop } from 'react-dnd'
import { type OrganizationAddress } from 'services'
import TabsComponent from './tab-component'
const ItemTypes = {
  CARD: 'card'
}

interface CardProps {
  address: OrganizationAddress
  index: number
  moveCard: (dragIndex: number, hoverIndex: number) => void
  deleteAddress: (index: number) => void
  reloadAddresses: () => void
}

export const OrgAddressCard: React.FC<CardProps> = ({ deleteAddress, address, index, moveCard, reloadAddresses }) => {
  const ref = React.useRef<HTMLDivElement>(null)
  const [, drop] = useDrop({
    accept: ItemTypes.CARD,
    hover (item: { index: number }, monitor: { getClientOffset: () => any }) {
      if (ref.current == null) {
        return
      }
      const dragIndex = item.index
      const hoverIndex = index
      if (dragIndex === hoverIndex) {
        return
      }
      const hoverBoundingRect = ref.current?.getBoundingClientRect()
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
      const clientOffset = monitor.getClientOffset()
      const hoverClientY = (clientOffset).y - hoverBoundingRect.top
      if (isDragAboveHover(dragIndex, hoverIndex, hoverClientY, hoverMiddleY)) {
        return
      }
      if (isDragBelowHover(dragIndex, hoverIndex, hoverClientY, hoverMiddleY)) {
        return
      }
      moveCard(dragIndex, hoverIndex)
      item.index = hoverIndex
    }
  })

  function isDragAboveHover (
    dragIndex: number,
    hoverIndex: number,
    hoverClientY: number | undefined,
    hoverMiddleY: number
  ): boolean {
    return dragIndex < hoverIndex && hoverClientY !== undefined && hoverClientY < hoverMiddleY
  }

  function isDragBelowHover (
    dragIndex: number,
    hoverIndex: number,
    hoverClientY: number | undefined,
    hoverMiddleY: number
  ): boolean {
    return dragIndex > hoverIndex && hoverClientY !== undefined && hoverClientY > hoverMiddleY
  }

  const [{ isDragging }, drag] = useDrag({
    type: ItemTypes.CARD,
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging()
    })
  })

  const opacity = isDragging ? 0.5 : 1
  drag(drop(ref))

  return (
    <Card ref={ref} style={{ opacity }}>
      <CardContent>
      <TabsComponent deleteAddress={deleteAddress} orgAddress={address} index={index} reloadAddresses={reloadAddresses}/>
      </CardContent>
    </Card>
  )
}
